export const CRISIS_HELPLINES = [
    {
        number: "988",
        label: "Suicide & Crisis Lifeline",
        detail: "call or text, 24/7",
        tel: "988",
    },
    {
        number: "1-800-662-4357",
        label: "SAMHSA National Helpline",
        detail: "free, confidential, 24/7",
        tel: "18006624357",
    },
    {
        number: "911",
        label: "for any medical emergency",
        tel: "911",
    },
];
